<template><router-view /></template>

<script>
export default { name: "ClaimsManagement" };
</script>
